// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lanauageFlag2 {\n  margin-top: -0.8em !important;\n}\n.tdBackGroundColor2 {\n  display: inline-block;\n  width: 30px;\n  height: 25px;\n  background: #ffb300;\n  border-radius: 10px;\n  color: #fff;\n  font-weight: 700;\n  padding-top: 2px;\n}\n.tdBackGroundColorNone2 {\n  display: inline-block;\n  width: 30px;\n  height: 25px;\n  background: #e4e4e4;\n  border-radius: 10px;\n  font-weight: 700;\n  padding-top: 2px;\n  opacity: 0.5;\n}", ""]);
// Exports
module.exports = exports;
